export const PROJECTS = [
  {
    id: "portfolio3dnext",
    titleKey: "projectsPage.projects.portfolio3dnext.title",
    subtitleKey: "projectsPage.projects.portfolio3dnext.subtitle",
    overviewKey: "projectsPage.projects.portfolio3dnext.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.portfolio3dnext.specifications.technical.0",
        "projectsPage.projects.portfolio3dnext.specifications.technical.1",
        "projectsPage.projects.portfolio3dnext.specifications.technical.2",
        "projectsPage.projects.portfolio3dnext.specifications.technical.3",
        "projectsPage.projects.portfolio3dnext.specifications.technical.4",
        "projectsPage.projects.portfolio3dnext.specifications.technical.5",
        "projectsPage.projects.portfolio3dnext.specifications.technical.6",
        "projectsPage.projects.portfolio3dnext.specifications.technical.7",
        "projectsPage.projects.portfolio3dnext.specifications.technical.8",
        "projectsPage.projects.portfolio3dnext.specifications.technical.9",
      ],
      functional: [
        "projectsPage.projects.portfolio3dnext.specifications.functional.0",
        "projectsPage.projects.portfolio3dnext.specifications.functional.1",
        "projectsPage.projects.portfolio3dnext.specifications.functional.2",
        "projectsPage.projects.portfolio3dnext.specifications.functional.3",
      ],
    },
    images: [
      "/images/project/Portfolio3DNext/Portfolio3DNextPix.webp",
      "/images/project/Portfolio3DNext/Portfolio3DNextPix-2.webp",
      "/images/project/Portfolio3DNext/Portfolio3DNextPix-3.webp",
    ],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/Frederic-K-Portfolio-3D-Next",
        labelKey: "github",
      },
      {
        type: "website",
        url: "https://frederic-k-portfolio-3d-next.netlify.app//",
        labelKey: "website",
      },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: [
      "nextjs",
      "threejs",
      "tailwindcss",
      "framerMotion",
      "zustand",
      "reactHookForm",
      "zod",
      "i18n",
      "emailjs",
      "responsiveness",
    ],
  },
  {
    id: "2tat",
    titleKey: "projectsPage.projects.2tat.title",
    subtitleKey: "projectsPage.projects.2tat.subtitle",
    overviewKey: "projectsPage.projects.2tat.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.2tat.specifications.technical.0",
        "projectsPage.projects.2tat.specifications.technical.1",
        "projectsPage.projects.2tat.specifications.technical.2",
        "projectsPage.projects.2tat.specifications.technical.3",
        "projectsPage.projects.2tat.specifications.technical.4",
      ],
      functional: [
        "projectsPage.projects.2tat.specifications.functional.0",
        "projectsPage.projects.2tat.specifications.functional.1",
      ],
    },
    images: [
      "/images/project/2tat/2tatPix.webp",
      "/images/project/2tat/2tatPix-2.webp",
      "/images/project/2tat/2tatPix-3.webp",
    ],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/Technical-Task-Assistance-Tool",
        labelKey: "github",
      },
      {
        type: "website",
        url: "https://2tat.netlify.app",
        labelKey: "website",
      },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: [
      "html",
      "css",
      "tailwind",
      "javascript",
      "react",
      "redux",
      "vite",
      "framerMotion",
      "tauri",
    ],
  },
  {
    id: "fredericksblogv2",
    titleKey: "projectsPage.projects.fredericksblogv2.title",
    subtitleKey: "projectsPage.projects.fredericksblogv2.subtitle",
    overviewKey: "projectsPage.projects.fredericksblogv2.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.fredericksblogv2.specifications.technical.0",
        "projectsPage.projects.fredericksblogv2.specifications.technical.1",
        "projectsPage.projects.fredericksblogv2.specifications.technical.2",
        "projectsPage.projects.fredericksblogv2.specifications.technical.3",
        "projectsPage.projects.fredericksblogv2.specifications.technical.4",
      ],
      functional: [
        "projectsPage.projects.fredericksblogv2.specifications.functional.0",
        "projectsPage.projects.fredericksblogv2.specifications.functional.1",
      ],
    },
    images: [
      "/images/project/FredericksBlogV2/FredericksBlogV2Pix.webp",
      "/images/project/FredericksBlogV2/FredericksBlogV2Pix-2.webp",
      "/images/project/FredericksBlogV2/FredericksBlogV2Pix-3.webp",
    ],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/Frederic-K-Blog",
        labelKey: "github",
      },
      {
        type: "website",
        url: "https://frederic-k-blog.onrender.com/",
        labelKey: "website",
      },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: [
      "html",
      "css",
      "tailwind",
      "javascript",
      "react",
      "redux",
      "rtkQuery",
      "mongodb",
      "express",
      "node",
      "json",
      "i18n",
      "framerMotion",
      "vite",
    ],
  },
  {
    id: "bookstoremernstack",
    titleKey: "projectsPage.projects.bookstoremernstack.title",
    subtitleKey: "projectsPage.projects.bookstoremernstack.subtitle",
    overviewKey: "projectsPage.projects.bookstoremernstack.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.bookstoremernstack.specifications.technical.0",
        "projectsPage.projects.bookstoremernstack.specifications.technical.1",
        "projectsPage.projects.bookstoremernstack.specifications.technical.2",
      ],
      functional: [
        "projectsPage.projects.bookstoremernstack.specifications.functional.0",
        "projectsPage.projects.bookstoremernstack.specifications.functional.1",
      ],
    },
    images: [
      "/images/project/BookstoreMernStack/BookstoreMernStackPix.webp",
      "/images/project/BookstoreMernStack/BookstoreMernStackPix-2.webp",
      "/images/project/BookstoreMernStack/BookstoreMernStackPix-3.webp",
    ],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/MERN-Book-Store",
        labelKey: "github",
      },
      // {
      //   type: "website",
      //   url: "https://bookstoremernstack.netlify.app/",
      //   labelKey: "website",
      // },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: ["html", "css", "javascript", "react", "mui", "vite", "mongodb", "express", "node"],
  },
  {
    id: "musicfestival",
    titleKey: "projectsPage.projects.musicfestival.title",
    subtitleKey: "projectsPage.projects.musicfestival.subtitle",
    overviewKey: "projectsPage.projects.musicfestival.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.musicfestival.specifications.technical.0",
        "projectsPage.projects.musicfestival.specifications.technical.1",
        "projectsPage.projects.musicfestival.specifications.technical.2",
        "projectsPage.projects.musicfestival.specifications.technical.3",
        "projectsPage.projects.musicfestival.specifications.technical.4",
        "projectsPage.projects.musicfestival.specifications.technical.5",
        "projectsPage.projects.musicfestival.specifications.technical.6",
      ],
      functional: [
        "projectsPage.projects.musicfestival.specifications.functional.0",
        "projectsPage.projects.musicfestival.specifications.functional.1",
        "projectsPage.projects.musicfestival.specifications.functional.2",
        "projectsPage.projects.musicfestival.specifications.functional.3",
      ],
      technology: [
        "projectsPage.projects.musicfestival.specifications.technology.0",
        "projectsPage.projects.musicfestival.specifications.technology.1",
        "projectsPage.projects.musicfestival.specifications.technology.2",
      ],
    },
    images: [
      "/images/project/MusicFestival/MusicFestivalPix.webp",
      "/images/project/MusicFestival/MusicFestivalPix-1.webp",
      "/images/project/MusicFestival/MusicFestivalPix-2.webp",
    ],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/TailwindcssPracticeMusicFestival",
        labelKey: "github",
      },
      {
        type: "website",
        url: "https://tailwindcsspracticemusicfestival.netlify.app/",
        labelKey: "website",
      },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: ["html", "tailwind"],
  },
  {
    id: "agenceazeon",
    titleKey: "projectsPage.projects.agenceazeon.title",
    subtitleKey: "projectsPage.projects.agenceazeon.subtitle",
    overviewKey: "projectsPage.projects.agenceazeon.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.agenceazeon.specifications.technical.0",
        "projectsPage.projects.agenceazeon.specifications.technical.1",
        "projectsPage.projects.agenceazeon.specifications.technical.2",
        "projectsPage.projects.agenceazeon.specifications.technical.3",
        "projectsPage.projects.agenceazeon.specifications.technical.4",
      ],
      functional: [
        "projectsPage.projects.agenceazeon.specifications.functional.0",
        "projectsPage.projects.agenceazeon.specifications.functional.1",
      ],
    },
    images: [
      "/images/project/AgenceAzeon/AgenceAzeonPix.webp",
      "/images/project/AgenceAzeon/AgenceAzeonPix-2.webp",
      "/images/project/AgenceAzeon/AgenceAzeonPix-3.webp",
    ],
    links: [
      // {
      //   type: "github",
      //   url: "https://github.com/Frederic-K/agenceazeon",
      //   labelKey: "github",
      // },
      // {
      //   type: "website",
      //   url: "https://agenceazeon.netlify.app/",
      //   labelKey: "website",
      // },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: ["html", "css", "sass", "javascript", "react", "redux", "rtkQuery", "mui", "i18n"],
  },
  {
    id: "portfoliolivecv",
    titleKey: "projectsPage.projects.portfoliolivecv.title",
    subtitleKey: "projectsPage.projects.portfoliolivecv.subtitle",
    overviewKey: "projectsPage.projects.portfoliolivecv.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.portfoliolivecv.specifications.technical.0",
        "projectsPage.projects.portfoliolivecv.specifications.technical.1",
        "projectsPage.projects.portfoliolivecv.specifications.technical.2",
      ],
      functional: [
        "projectsPage.projects.portfoliolivecv.specifications.functional.0",
        "projectsPage.projects.portfoliolivecv.specifications.functional.1",
      ],
    },
    images: [
      "/images/project/PortfolioLiveCV/PortfolioLiveCVPix.webp",
      "/images/project/PortfolioLiveCV/PortfolioLiveCVPix-2.webp",
      "/images/project/PortfolioLiveCV/PortfolioLiveCVPix-3.webp",
    ],
    links: [
      // {
      //   type: "github",
      //   url: "https://github.com/Frederic-K/Portfolio-Live-CV",
      //   labelKey: "github",
      // },
      {
        type: "website",
        url: "https://frederic-k-letsmeet.netlify.app/",
        labelKey: "website",
      },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: ["html", "css", "sass", "javascript", "react", "redux", "mui"],
  },
  {
    id: "wealthhealth",
    titleKey: "projectsPage.projects.wealthhealth.title",
    subtitleKey: "projectsPage.projects.wealthhealth.subtitle",
    overviewKey: "projectsPage.projects.wealthhealth.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.wealthhealth.specifications.technical.0",
        "projectsPage.projects.wealthhealth.specifications.technical.1",
        "projectsPage.projects.wealthhealth.specifications.technical.2",
      ],
      functional: [
        "projectsPage.projects.wealthhealth.specifications.functional.0",
        "projectsPage.projects.wealthhealth.specifications.functional.1",
      ],
    },
    images: [
      "/images/project/WealthHealth/WealthHealthPix.webp",
      "/images/project/WealthHealth/WealthHealthPix-2.webp",
      "/images/project/WealthHealth/WealthHealthPix-3.webp",
      "/images/project/WealthHealth/NpmInfoModalComponentPix.webp",
    ],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/WealthHealthHRnet",
        labelKey: "github",
      },
      {
        type: "website",
        url: "https://wealthhealthhrnet.netlify.app",
        labelKey: "website",
      },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: ["html", "css", "sass", "javascript", "react", "redux", "mui", "npm"],
  },
  {
    id: "argentbank",
    titleKey: "projectsPage.projects.argentbank.title",
    subtitleKey: "projectsPage.projects.argentbank.subtitle",
    overviewKey: "projectsPage.projects.argentbank.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.argentbank.specifications.technical.0",
        "projectsPage.projects.argentbank.specifications.technical.1",
        "projectsPage.projects.argentbank.specifications.technical.2",
        "projectsPage.projects.argentbank.specifications.technical.3",
        "projectsPage.projects.argentbank.specifications.technical.4",
      ],
      functional: [
        "projectsPage.projects.argentbank.specifications.functional.0",
        "projectsPage.projects.argentbank.specifications.functional.1",
        "projectsPage.projects.argentbank.specifications.functional.2",
        "projectsPage.projects.argentbank.specifications.functional.3",
        "projectsPage.projects.argentbank.specifications.functional.4",
        "projectsPage.projects.argentbank.specifications.functional.5",
        "projectsPage.projects.argentbank.specifications.functional.6",
        "projectsPage.projects.argentbank.specifications.functional.7",
      ],
    },
    images: [
      "/images/project/ArgentBank/ArgentBankPix.webp",
      "/images/project/ArgentBank/ArgentBankPix-2.webp",
    ],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/ArgentBank",
        labelKey: "github",
      },
      // {
      //   type: "website",
      //   url: "https://argentbank.netlify.app/",
      //   labelKey: "website",
      // },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: ["html", "css", "sass", "javascript", "react", "redux"],
  },
  {
    id: "sportsee",
    titleKey: "projectsPage.projects.sportsee.title",
    subtitleKey: "projectsPage.projects.sportsee.subtitle",
    overviewKey: "projectsPage.projects.sportsee.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.sportsee.specifications.technical.0",
        "projectsPage.projects.sportsee.specifications.technical.1",
        "projectsPage.projects.sportsee.specifications.technical.2",
        "projectsPage.projects.sportsee.specifications.technical.3",
        "projectsPage.projects.sportsee.specifications.technical.4",
        "projectsPage.projects.sportsee.specifications.technical.5",
        "projectsPage.projects.sportsee.specifications.technical.6",
        "projectsPage.projects.sportsee.specifications.technical.7",
      ],
      functional: [
        "projectsPage.projects.sportsee.specifications.functional.0",
        "projectsPage.projects.sportsee.specifications.functional.1",
        "projectsPage.projects.sportsee.specifications.functional.2",
        "projectsPage.projects.sportsee.specifications.functional.3",
      ],
    },
    images: [
      "/images/project/Sportsee/SportseePix.webp",
      "/images/project/Sportsee/SportseePix-2.webp",
    ],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/SportSee-Frontend",
        labelKey: "github",
      },
      // {
      //   type: "website",
      //   url: "https://sportsee.netlify.app/",
      //   labelKey: "website",
      // },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: ["html", "css", "sass", "javascript", "react"],
  },
  {
    id: "kasa",
    titleKey: "projectsPage.projects.kasa.title",
    subtitleKey: "projectsPage.projects.kasa.subtitle",
    overviewKey: "projectsPage.projects.kasa.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.kasa.specifications.technical.0",
        "projectsPage.projects.kasa.specifications.technical.1",
        "projectsPage.projects.kasa.specifications.technical.2",
        "projectsPage.projects.kasa.specifications.technical.3",
        "projectsPage.projects.kasa.specifications.technical.4",
        "projectsPage.projects.kasa.specifications.technical.5",
        "projectsPage.projects.kasa.specifications.technical.6",
        "projectsPage.projects.kasa.specifications.technical.7",
        "projectsPage.projects.kasa.specifications.technical.8",
        "projectsPage.projects.kasa.specifications.technical.9",
        "projectsPage.projects.kasa.specifications.technical.10",
      ],
      functional: [
        "projectsPage.projects.kasa.specifications.functional.0",
        "projectsPage.projects.kasa.specifications.functional.1",
      ],
    },
    images: ["/images/project/Kasa/KasaPix.webp", "/images/project/Kasa/KasaPix-2.webp"],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/Kasa",
        labelKey: "github",
      },
      // {
      //   type: "website",
      //   url: "https://kasa.netlify.app/",
      //   labelKey: "website",
      // },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: ["html", "css", "sass", "javascript", "react"],
  },
  {
    id: "learnathome",
    titleKey: "projectsPage.projects.learnathome.title",
    subtitleKey: "projectsPage.projects.learnathome.subtitle",
    overviewKey: "projectsPage.projects.learnathome.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.learnathome.specifications.technical.0",
        "projectsPage.projects.learnathome.specifications.technical.1",
        "projectsPage.projects.learnathome.specifications.technical.2",
      ],
      functional: [
        "projectsPage.projects.learnathome.specifications.functional.0",
        "projectsPage.projects.learnathome.specifications.functional.1",
        "projectsPage.projects.learnathome.specifications.functional.2",
        "projectsPage.projects.learnathome.specifications.functional.3",
        "projectsPage.projects.learnathome.specifications.functional.4",
      ],
    },
    images: [
      "/images/project/LearnAtHome/LearnAtHomePix.webp",
      "/images/project/LearnAtHome/LearnAtHomePix-2.webp",
      "/images/project/LearnAtHome/LearnAtHomePix-3.webp",
    ],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/Learn-home",
        labelKey: "github",
      },
      // {
      //   type: "website",
      //   url: "https://learnathome.netlify.app/",
      //   labelKey: "website",
      // },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: ["figma"],
  },
  {
    id: "lespetitsplats",
    titleKey: "projectsPage.projects.lespetitsplats.title",
    subtitleKey: "projectsPage.projects.lespetitsplats.subtitle",
    overviewKey: "projectsPage.projects.lespetitsplats.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.lespetitsplats.specifications.technical.0",
        "projectsPage.projects.lespetitsplats.specifications.technical.1",
        "projectsPage.projects.lespetitsplats.specifications.technical.2",
        "projectsPage.projects.lespetitsplats.specifications.technical.3",
        "projectsPage.projects.lespetitsplats.specifications.technical.4",
        "projectsPage.projects.lespetitsplats.specifications.technical.5",
      ],
      functional: [
        "projectsPage.projects.lespetitsplats.specifications.functional.0",
        "projectsPage.projects.lespetitsplats.specifications.functional.1",
        "projectsPage.projects.lespetitsplats.specifications.functional.2",
        "projectsPage.projects.lespetitsplats.specifications.functional.3",
        "projectsPage.projects.lespetitsplats.specifications.functional.4",
      ],
    },
    images: [
      "/images/project/LesPetitsPlats/LesPetitsPlatsPix.webp",
      "/images/project/LesPetitsPlats/LesPetitsPlatsPix-2.webp",
    ],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/Les-petits-plats",
        labelKey: "github",
      },
      {
        type: "website",
        url: "https://lespetitsplats.netlify.app/",
        labelKey: "website",
      },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: ["html", "css", "sass", "javascript"],
  },
  {
    id: "fisheye",
    titleKey: "projectsPage.projects.fisheye.title",
    subtitleKey: "projectsPage.projects.fisheye.subtitle",
    overviewKey: "projectsPage.projects.fisheye.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.fisheye.specifications.technical.0",
        "projectsPage.projects.fisheye.specifications.technical.1",
        "projectsPage.projects.fisheye.specifications.technical.2",
        "projectsPage.projects.fisheye.specifications.technical.3",
        "projectsPage.projects.fisheye.specifications.technical.4",
      ],
      functional: [
        "projectsPage.projects.fisheye.specifications.functional.0",
        "projectsPage.projects.fisheye.specifications.functional.1",
        "projectsPage.projects.fisheye.specifications.functional.2",
        "projectsPage.projects.fisheye.specifications.functional.3",
        "projectsPage.projects.fisheye.specifications.functional.4",
        "projectsPage.projects.fisheye.specifications.functional.5",
        "projectsPage.projects.fisheye.specifications.functional.6",
      ],
    },
    images: [
      "/images/project/Fisheye/FisheyePix.webp",
      "/images/project/Fisheye/FisheyePix-2.webp",
      "/images/project/Fisheye/FisheyePix-3.webp",
    ],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/Fisheye",
        labelKey: "github",
      },
      // {
      //   type: "website",
      //   url: "https://fisheye.netlify.app/",
      //   labelKey: "website",
      // },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: ["html", "css", "sass", "javascript"],
  },
  {
    id: "gameon",
    titleKey: "projectsPage.projects.gameon.title",
    subtitleKey: "projectsPage.projects.gameon.subtitle",
    overviewKey: "projectsPage.projects.gameon.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.gameon.specifications.technical.0",
        "projectsPage.projects.gameon.specifications.technical.1",
        "projectsPage.projects.gameon.specifications.technical.2",
        "projectsPage.projects.gameon.specifications.technical.3",
        "projectsPage.projects.gameon.specifications.technical.4",
        "projectsPage.projects.gameon.specifications.technical.5",
      ],
      functional: [
        "projectsPage.projects.gameon.specifications.functional.0",
        "projectsPage.projects.gameon.specifications.functional.1",
        "projectsPage.projects.gameon.specifications.functional.2",
        "projectsPage.projects.gameon.specifications.functional.3",
        "projectsPage.projects.gameon.specifications.functional.4",
      ],
    },
    images: ["/images/project/GameOn/GameonPix.webp", "/images/project/GameOn/GameonPix-2.webp"],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/GameOn-website-FR",
        labelKey: "github",
      },
      // {
      //   type: "website",
      //   url: "https://gameon.netlify.app/",
      //   labelKey: "website",
      // },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: ["html", "css", "sass", "javascript"],
  },
  {
    id: "ohmyfood",
    titleKey: "projectsPage.projects.ohmyfood.title",
    subtitleKey: "projectsPage.projects.ohmyfood.subtitle",
    overviewKey: "projectsPage.projects.ohmyfood.overview",
    specificationsKeys: {
      technical: [
        "projectsPage.projects.ohmyfood.specifications.technical.0",
        "projectsPage.projects.ohmyfood.specifications.technical.1",
        "projectsPage.projects.ohmyfood.specifications.technical.2",
        "projectsPage.projects.ohmyfood.specifications.technical.3",
        "projectsPage.projects.ohmyfood.specifications.technical.4",
      ],
      functional: [
        "projectsPage.projects.ohmyfood.specifications.functional.0",
        "projectsPage.projects.ohmyfood.specifications.functional.1",
        "projectsPage.projects.ohmyfood.specifications.functional.2",
        "projectsPage.projects.ohmyfood.specifications.functional.3",
        "projectsPage.projects.ohmyfood.specifications.functional.4",
        "projectsPage.projects.ohmyfood.specifications.functional.5",
        "projectsPage.projects.ohmyfood.specifications.functional.6",
      ],
    },
    images: [
      "/images/project/Ohmyfood/OhmyfoodPix.webp",
      "/images/project/Ohmyfood/OhmyfoodPix-2.webp",
      "/images/project/Ohmyfood/OhmyfoodPix-3.webp",
    ],
    links: [
      {
        type: "github",
        url: "https://github.com/Frederic-K/Ohmyfood",
        labelKey: "github",
      },
      // {
      //   type: "website",
      //   url: "https://ohmyfood.netlify.app/",
      //   labelKey: "website",
      // },
      {
        type: "readme",
        url: "",
        labelKey: "",
      },
    ],
    skillsKeys: ["html", "css", "sass"],
  },

  // TODO : Repeat the above structure for each new project
]
